import { render } from "./WalletInfo.vue?vue&type=template&id=38de6ac4&scoped=true"
import script from "./WalletInfo.vue?vue&type=script&lang=js"
export * from "./WalletInfo.vue?vue&type=script&lang=js"

import "./WalletInfo.vue?vue&type=style&index=0&id=38de6ac4&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38de6ac4"]])

export default __exports__